import { sort } from '@/utils';

enum DepartmentsEnum {
  Adamova = 'Adamova',
  Atroshko = 'Atroshko',
  Botko = 'Botko',
  Chakur = 'Chakur',
  Chirkova = 'Chirkova',
  Ermolik = 'Ermolik',
  Gomanchuk = 'Gomanchuk',
  Gorbach = 'Gorbach',
  Kalganov = 'Kalganov',
  Korolev = 'Korolev',
  Korzun = 'Korzun',
  Knysh = 'Knysh',
  Krivodubsky = 'Krivodubsky',
  Mahnach = 'Mahnach',
  MazurGrabovsky = 'Mazur-Grabovsky',
  Nikitin = 'Nikitin',
  Rekut = 'Rekut',
  Romanchenko = 'Romanchenko',
  Rudovich = 'Rudovich',
  Salesforce = 'Salesforce',
  Shults = 'Shults',
  Sinkevich = 'Sinkevich',
  Strelchenko = 'Strelchenko',
  Suboch = 'Suboch',
  Trukhan = 'Trukhan',
  Tsvilik = 'Tsvilik',
}

const departmentsData = new Map([
  [DepartmentsEnum.Adamova, ['Adamova', 'Kosyak', 'Yasko', 'Zantovich']],
  [DepartmentsEnum.Atroshko, ['Atroshko', 'Kurilo', 'Matylkova']],
  [DepartmentsEnum.Botko, ['Botko']],
  [DepartmentsEnum.Chakur, ['Chakur', 'Kurilovich', 'Nesterovich', 'Teryohin']],
  [DepartmentsEnum.Chirkova, ['Chirkova', 'Lysova', 'Susha']],
  [DepartmentsEnum.Ermolik, ['Ermolik']],
  [DepartmentsEnum.Gomanchuk, ['Gomanchuk', 'Kortelev']],
  [DepartmentsEnum.Gorbach, ['Gorbach']],
  [DepartmentsEnum.Kalganov, ['Deykalo', 'Kalganov', 'Smykovskaya']],
  [DepartmentsEnum.Korolev, ['Korolev', 'Protchenko']],
  [DepartmentsEnum.Korzun, ['Ivanov', 'Korzun Anastasiya', 'Korzun Andrey', 'Krukovsky', 'Stoyko']],
  [DepartmentsEnum.Knysh, ['Knysh']],
  [DepartmentsEnum.Krivodubsky, ['Krivodubsky']],
  [DepartmentsEnum.Mahnach, ['Mahnach', 'Rusak', 'Shilovich', 'Tereshchenko']],
  [DepartmentsEnum.MazurGrabovsky, ['Korzun', 'Matusevich', 'Mazur-Grabovsky', 'Vlasov']],
  [DepartmentsEnum.Nikitin, ['Nikitin', 'Shevchik', 'Tihanovskaya', 'Vinokurova']],
  [DepartmentsEnum.Rekut, ['Artimenya', 'Rekut', 'Rumyantsev', 'Shkuda']],
  [DepartmentsEnum.Romanchenko, ['Ahramovich', 'Petrov', 'Romanchenko', 'Shults']],
  [DepartmentsEnum.Rudovich, ['Bozhik', 'Rudovich']],
  [DepartmentsEnum.Salesforce, ['Denizhenko', 'Korolev']],
  [DepartmentsEnum.Shults, ['Aleksandrovich', 'Kovalenko', 'Povedyonok', 'Romanko', 'Shults']],
  [DepartmentsEnum.Sinkevich, ['Serov', 'Sinkevich']],
  [DepartmentsEnum.Strelchenko, ['Strelchenko']],
  [DepartmentsEnum.Suboch, ['Ankuda', 'Birilo', 'Finberg', 'Goloviy', 'Lukashonok', 'Suboch']],
  [DepartmentsEnum.Trukhan, ['Trukhan']],
  [DepartmentsEnum.Tsvilik, ['Tsvilik']],
]);

const handleUnitManagers = (department: string, unitManagers: string[]) =>
  unitManagers.sort(sort).map((x) => ({ value: `${x}_${department}`, title: x }));

export const useDepartmentsTreeData = () => {
  return Array.from(departmentsData, ([department, unitManagers]) => ({
    value: `department_${department}`,
    title: department,
    children: handleUnitManagers(department, unitManagers),
  })).sort((a, b) => sort(a.title, b.title));
};
